import { CustomerCredits } from '@src/containers/Dealer/CustomerCredits';
import type { CustomerCreditsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerCreditsPanel({ api, params }: LayoutPanelProps<CustomerCreditsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-credits-panel"
    >
      <CustomerCredits />
    </EntityAdminPanelShell>
  );
}
